<template>
  <div class="right-menu__changepassword">
    <div class="right-menu__title">
      <h4>Новый пароль</h4>
    </div>
    <div class="t-form">
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.password }">
          <input
            type="password"
            id="change-password-old"
            v-model="data.password"
            @click="() => clearError('password')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.password }"
            for="change-password-old"
          >
            Новый пароль
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.passwordText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.passwordRepeat }">
          <input
            type="password"
            id="change-password-new"
            v-model="data.passwordRepeat"
            @click="() => clearError('passwordRepeat')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.passwordRepeat }"
            for="change-password-new"
          >
            Повторите пароль
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{
            errors.passwordRepeatText
          }}</span>
        </div>
      </div>
    </div>
    <t-button type="small blue uppercase" :callback="submit"
      >Подтвердить</t-button
    >
  </div>
</template>

<script>
import Button from '@components/ui/button.vue';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  components: {
    't-button': Button,
  },
  data: function() {
    return {
      data: {
        password: '',
        passwordRepeat: '',
      },
      retypePassword: '',
      errors: {
        password: false,
        passwordRepeat: false,
        passwordText: '',
        passwordRepeatText: '',
      },
      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  computed: {
    ...mapState('api', ['passwordRecover']),
    ...mapState('params', ['token']),
  },
  methods: {
    ...mapMutations('params', [
      'toogleUserMenu',
      'toggleRightMenu',
      'setAuthOn',
      'toggleNewPasswordBlock',
    ]),
    ...mapActions('api', ['fetchRequest']),

    validation: function() {
      let error = false;

      Object.keys(this.data).forEach((item) => {
        if (!this.data[item].trim()) {
          this.setErrors(item, 'empty');
          error = true;
        }
      });

      Object.keys(this.data).forEach((item) => {
        if (!this.data[item].trim() && this.data[item].trim().length < 7) {
          this.setErrors(item, 'shortPassword');
          error = true;
        }
      });

      if (this.data.password != this.data.passwordRepeat) {
        this.setErrors(password, 'mismatchPassword');
        this.setErrors(passwordRepeat, 'mismatchPassword');
        error = false;
      }

      return error;
    },
    setErrors: function(id, error) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = this.errorsText[error];
    },

    clearError: function(id) {
      this.errors[id] = false;
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },

    submit: function() {
      console.log('this.passwordRecover', this.data);

      if (this.validation()) return;

      this.fetchRequest({
        url: this.passwordRecover,
        form: this.form({ newPassword: this.data.password, token: this.token }),
        success: (data) => {
          console.log('success', data);
          if (data.body.success) {
            this.$router.push('/personal');
            this.setAuthOn();
            this.toggleRightMenu();
            this.toogleUserMenu();
            this.toggleNewPasswordBlock();
          }
        },
        error: (e) => {
          console.log('error', e);
        },
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.marginBottom
  margin-bottom: 32px
</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/newpassword.vue